import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { MainLayout } from "./components/layout/MainLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import WorkItems from "./pages/WorkItems";
import WorkItemDetail from "./pages/WorkItemDetail";
import TimeEntries from "./pages/TimeEntries";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Sprint from "./pages/Sprint";
import Users from "./pages/Users";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/work-items" element={<WorkItems />} />
            <Route path="/work-items/new" element={<WorkItems />} />
            <Route path="/work-items/:id" element={<WorkItemDetail />} />
            <Route path="/sprint" element={<Sprint />} />
            <Route path="/time-entries" element={<TimeEntries />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/users" element={<Users />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
